import api from '@/api';
import makeSorter from '@/lib/makeSorter';
import { regexpSearch } from '@/lib/searchFns';
import ___ from '../constants';
import { result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';
import { message } from 'antd';

const dateColumns = [
    'est_arrival_date',
]

const initialState = {
    currentEditRow: null,
    currentEditHeader: null,
    detailLines: null,
    originalOrders: [],
    filteredOrders: [],
    loading: false,
    searchLoading: false,
    modalType: null,
    columns: [],
    filteredSource: [],
    searchedSource: [],
    sortOrder: false,
    sortField: false,
    sorting: [],
    filters: [],
    // FUTURE FEATURE DEFAULT WAREHOUSE
    //warehouseOptions: [],
    binOptions: [],
    warehouseRows: [],
    locationRows: [],
};

export const types = {
    SET_STATE: 'INCOMING/SET_STATE',
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            // DEBUG console.log('[Reducer] SET_STATE:', action.data);
            return { ...state, ...action.data };



        default:
            return state;
    }
};




export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),


    setCurrentEditRow: (row) => async (dispatch, getState) => {
        //console.log('[Incoming.redux.js] setCurrentEditRow');
        //console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getIncoming: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncoming()');
        const state = getState();
        dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Warehouse.GetInbound
            let result = await api.get('/warehouse/receiving');
            //console.log(result)
            //console.log(result.incomingOrders.recordset)
            let _result = result.incomingOrders.recordset;

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value)
            }
            //console.log(_arrayResult)

            dispatch(actions.setState({
                originalOrders: _arrayResult,
                filteredOrders: _arrayResult,
                filteredSource: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('getIncoming catch err')
            console.error(err);
            dispatch(actions.setState({
                originalOrders: [],
                filteredOrders: [],
                filteredSource: [],
                loading: false
            }));
        }
    },

    searchCurrent: ({ searchValue = '', excludeList = [], includeList = [], exactList = [] }) => (dispatch, getState) => {
        console.log('[Incoming.redux] searchCurrent');

        const finalIncludeList = subtractFields(includeList, excludeList, exactList);
        const finalExactList = exactList.filter(field => !excludeList.includes(field));

        dispatch(actions.setState({ searchLoading: true }));

        setTimeout(() => {
            const { filteredSource, sortOrder, sortField } = getState().warehouse;
            let searchedSource = [];

            for (let bp of filteredSource) {
                if (searchValue === '') {
                    searchedSource.push(bp);
                    continue;
                }

                const matchedInclude = matchesIncludeFields(bp, finalIncludeList, searchValue);
                const matchedExact = matchesExactFields(bp, finalExactList, searchValue);

                if (matchedInclude || matchedExact) {
                    searchedSource.push(bp);
                }
            }

            dispatch(actions.setState({
                searchedSource: [...searchedSource],
                searchValue,
                hasFilterBeenApplied: true,
                hasOrder: true,
            }));

            dispatch(actions.sortCurrent({
                field: sortField,
                order: sortOrder
            }));

            dispatch(actions.setState({ searchLoading: false }));
        }, 1000); // 1 second delay
    },

    sortCurrent: ({ field, order }) => (dispatch, getState) => {
        //console.log('[Incoming.redux] sortCurrent ')
        //console.log(field)
        //console.log(order)
        let { searchedSource, columns } = getState().warehouse;

        const numberSortColumns = [
            ...dateColumns,
            'card_code',
        ];

        let newColumns = columns.map((col) => {
            if (col.dataIndex === field) {
                return { ...col, sortOrder: order }
            } else {
                return { ...col, sortOrder: false }
            }
        });

        let incomingOrders = searchedSource; // IMPORTANT

        if (field !== false) {
            let type = 'string';
            if (numberSortColumns.indexOf(field) !== -1) {
                type = 'number';
            }
            incomingOrders = searchedSource.sort(makeSorter(type, field));
        }

        if (order === 'ascend') {
            incomingOrders = incomingOrders.reverse();
        }

        dispatch(actions.setState({
            columns: newColumns,
            filteredOrders: [...incomingOrders],
            sortOrder: order,
            sortField: field,
        }));
    },

    getIncomingPODetails: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncomingPODetails()');
        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));

        //console.log(state.currentEditRow)
        //console.log(state.currentEditRow.docKey)
        //console.log(state.currentEditRow.docEntry)

        try {
            // QUERY Warehouse.GetPurchaseOrderLines
            let result = await api.get(`/warehouse/receiving/po-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docKey: state.currentEditRow.docKey
                }
            });
            //console.log(result)
            console.log(result.detailLines.recordset)
            dispatch(actions.setState({ detailLines: result.detailLines.recordset, modalType: ___.PURCHASE_ORDER }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    writePurchaseOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writePurchaseOrder()');
        //console.log(currentEditRow);
        //console.log(editDetailsLines);

        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));

        const hasExtras = (r) => Array.isArray(r.extraAllocations) && r.extraAllocations.length > 0;
        const isManaged = (r) => r.isBatched === 'Y' || r.isSerial === 'Y';

        // batch/serial lines can carry their whole quantity in extra rows, so a
        // zero-qty parent with extras still submits; everything else keeps the
        // original orderQty > 0 filter
        let _filtered = editDetailsLines
            .filter((r) =>
                isManaged(r)
                    ? ((r.orderQty && r.orderQty > 0) || hasExtras(r))
                    : (r.orderQty && r.orderQty > 0))
            .map((r) => {
                if (!isManaged(r)) return r;

                // one allocation per batch/qty (or serial) row; the parent row is
                // the first pair, extra rows inherit the line's receiving bin
                const allocationsList = [
                    ...((r.orderQty && r.orderQty > 0) ? [{
                        serialOrBatchNum: r.serialOrBatchNum,
                        selectedQuantity: r.isSerial === 'Y' ? 1 : r.orderQty,
                        binNumber: r.receiveBinNumber,
                    }] : []),
                    ...(r.extraAllocations ?? []).map((a) => ({
                        serialOrBatchNum: a.serialOrBatchNum,
                        selectedQuantity: r.isSerial === 'Y' ? 1 : a.orderQty,
                        binNumber: r.receiveBinNumber,
                    })),
                ];

                const { extraAllocations, ...rest } = r;
                return {
                    ...rest,
                    allocationsList,
                    orderQty: allocationsList.reduce((total, a) => total + (a.selectedQuantity || 0), 0),
                };
            });
        //console.log(_filtered);

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
            submitRows: _filtered,
            //WhsCode: 'TODO', // backend DEFAULT_WHS_CODE = 'RM';
        };

        // service POs must produce a service-type GRPO
        if (currentEditRow.docType === 'S') {
            sendBody.DocType = 'S';
        }

        // TODO_BLANK_NOTES need to prevent writing comments if they are blank, except when they would be intentionally blank
        if (currentEditRow.notes && currentEditRow.notes !== '') {
            sendBody.Comments = currentEditRow.notes;
        }

        if (currentEditRow.reference_number && currentEditRow.reference_number !== '') {
            sendBody.reference_number = currentEditRow.reference_number;
        }

        try {
            let result = await api.put('/warehouse/write-grpo',
                sendBody);
            console.log(result);

            //console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB(result.responses[0]); // hardcoded zero index, popSuccessWithNum
                dispatch(actions.getIncoming());
                //dispatch(actions.setState({ purchaseOrders: result.purchaseOrders.recordset }));
            }

            //console.log(result.errorMsg); // errorMsg: "One of the base documents has already been closed"

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            const errorMsg =
                    err.response?.data?.errorMsg ||
                    err.response?.data?.message ||
                    err.response?.data?.errors?.[0] ||
                    err.message ||
                    'Could not write purchase order';

                message.error(errorMsg);
            dispatch(actions.setState({ loading: false }));
        }
    },
    getWarehouseLocations: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getWarehouseLocations()');
        //dispatch(actions.setState({ loading: true }));

        try {
            // QUERY Transfer.GetWarehouses + Transfer.AllLocations
            let result = await api.get('/warehouse/all-locations/'
                // , { params: { search: _search } }
            );
            console.log(result)
            dispatch(actions.setState({
                warehouseRows: result.warehouses,
                locationRows: result.locations,
                //loading: false
            }));
        } catch (err) {
            console.error('[Transfers.redux] catch err')
            console.error(err);
            dispatch(actions.setState({
                warehouseRows: [],
                locationRows: [],
                //loading: false
            }));
        }
    },
    // get_warehouse_options: () => async (dispatch) => {
    //     console.log('[Incoming.redux] get_warehouse_options');
    //     dispatch(actions.setState({ loading: true }));

    //     api.get('/warehouse/get-warehouse-options-po/').then(res => {
    //         let warehouseOptions = res.options;

    //         dispatch(actions.setState({ warehouseOptions }));
    //         dispatch(actions.setState({ loading: false }));
    //     }).catch(err => {
    //         console.error(err);
    //         dispatch(actions.setState({ loading: false }));
    //     });
    // },
    get_bin_options: (whsCode) => async (dispatch) => {
        // TODO_DEFAULT_BINS - this is only used by the alternate version of default bins
        console.log('[Incoming.redux.js] get_bin_options', whsCode);
        dispatch(actions.setState({ loading: true }));

        api.get(`/warehouse/get-bin-options/${whsCode}`)
            .then(res => {
                let binOptions = res.options;

                dispatch(actions.setState({ binOptions }));
                dispatch(actions.setState({ loading: false }));
            }).catch(err => {
                console.error(err);
                dispatch(actions.setState({ loading: false }));
            });
    },
};
